import React from "react";

/** Invalid-state ring for readable-register `.field` inputs. */
export function fieldClass(invalid) {
  return invalid ? "field ring-2 ring-red-500/30 border-red-400/60" : "field";
}

/** Inline validation message — pairs with `aria-describedby` on the field. */
export default function FormFieldError({ id, children, className = "", ...rest }) {
  return (
    <p
      id={id}
      role="alert"
      tabIndex={-1}
      className={`mt-1.5 font-ui text-[13px] font-medium text-red-700 leading-relaxed outline-none ${className}`}
      {...rest}
    >
      {children}
    </p>
  );
}
